import React from 'react';
import { bio, bioTagline } from '../data/masterclass';
export function Bio() {
  return <section aria-labelledby="bio-heading" className="border-y border-ink-line bg-ink" data-id="element-13" data-mp="3j82wr0yixsnq">
      <div className="mx-auto w-full max-w-3xl px-6 py-20 lg:py-24" data-id="element-14" data-mp="12gfyh9i3ohq">
        <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-15" data-mp="zltkk6xftlo">
          Your hosts
        </p>
        <h2 id="bio-heading" className="mt-3 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-16" data-mp="35fwqq7p35220">
          Curtis &amp; Spring Eatmon IV
        </h2>

        <div className="mt-8 space-y-6" data-id="element-17" data-mp="3e904yi7k1ixp">
          {bio.map(paragraph => <p key={paragraph} className="text-lg leading-relaxed text-white/70" data-id="element-18" data-mp="39hrtzhqktpif">
              {paragraph}
            </p>)}
        </div>

        <p className="mt-10 border-l-2 border-gold pl-6 font-display text-2xl font-semibold uppercase leading-snug text-gold sm:text-3xl" data-id="element-19" data-mp="2lquoampdjofm">
          {bioTagline}
        </p>
      </div>
    </section>;
}